module.exports = __webpack_public_path__ + "static/img/pc-web-img01@t.ca08d1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/pc-web-img01@t.png
// module id = u7Lz
// module chunks = 0